





































































































import AppLayout from '@/Layouts/AppLayout.vue'
import {Component, Prop, Provide} from 'vue-property-decorator';
import Vue from 'vue';
import EdelmanLogo from '@/Components/EdelmanLogo.vue';
import FormIndexActions from '@/Components/Admin/FormIndexActions.vue';
import User from '@/Types/User';
import {ColumnDef, Scope} from '@/Types/VueDataTable';

@Component({
    components: {
        EdelmanLogo,
        AppLayout,
        FormIndexActions,
    },
})
export default class Index extends Vue {
    @Prop({type: Array, required: true}) users!: User[]

    @Provide() stringFilter: string = '';
    @Provide() onlyComplete: boolean = false;

    onFirstDataRendered(params: { api: any }) {
        params.api.sizeColumnsToFit();
    }

    get columns(): ColumnDef[] {
        const columns: ColumnDef[] = [
            {
                prop: 'name',
            }, {
                prop: 'email',
            }, {
                prop: 'company',
            }, {
                prop: 'form.progress',
                label: 'Progress',
                width: '100px',
                formatter: (row, column, value) => `${value || 0}%`,
            },
        ]

        return columns.map(column => ({
            label: column.label || `${column.prop.slice(0, 1).toUpperCase()}${column.prop.slice(1).toLowerCase()}`,
            ...column,
        }));
    }

    canDownloadPresentation(scope: Scope): boolean {
        return this.hasForm(scope) && scope.row.form?.progress === 100;
    }

    hasForm(scope: Scope): boolean {
        return !!scope.row.form?.id;
    }

    editLink(scope: Scope): string {
        return this.route('admin--user--edit', {
            userId: scope.row.id,
        });
    }

    detailLink(scope: Scope): string {
        return this.hasForm(scope) ? this.route('admin--form--detail', {
            formId: scope.row.form?.id,
        }) : '';
    }

    downloadLink(scope: Scope): string {
        return this.hasForm(scope) ? this.route('admin--form--download', {
            formId: scope.row.form?.id,
        }) : '';
    }

    downloadRawLink(scope: Scope): string {
        return this.hasForm(scope) ? this.route('admin--form--export', {
            formId: scope.row.form?.id,
        }) : '';
    }

    impersonateLink(scope: Scope): string {
        return this.route('impersonate', {
            id: scope.row.id,
        });
    }

    filterProgress(row: User): boolean {
        return this.onlyComplete ? row.form?.progress === 100 : true
    }
}
